// Uses largest remainder method to ensure rounded percentages sum to 100
export const roundPercentages = (values: number[]) => {
  if (values.every((value) => Number.isInteger(value))) {
    return values;
  }
  const splitValues = values.map((value, index) => ({
    integerValue: Math.floor(value),
    decimalValue: value - Math.floor(value),
    index,
  }));
  const remainder =
    100 - splitValues.reduce((prev, cur) => prev + cur.integerValue, 0);
  const sortedValues = splitValues.sort(
    (a, b) => b.decimalValue - a.decimalValue,
  );
  for (let i = 0; i < remainder; i += 1) {
    sortedValues[i].integerValue = sortedValues[i].integerValue + 1;
  }
  return sortedValues
    .sort((a, b) => a.index - b.index)
    .map((value) => value.integerValue);
};
